import Button from '@material-ui/core/Button';
import React, { Component } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import { AiOutlineClose } from 'react-icons/ai';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import { bindActionCreators, Dispatch } from 'redux';
import DIRECTV_GO from '~/assets/DIRECTV_GO_LOGO_HORIZONTAL_RGB.svg';
import logoSky from '~/assets/log-SKY.svg';
import EnterPassword from '~/components/AuthWrapper/EnterPassword';
import RequestPassword from '~/components/AuthWrapper/requestPassword';
import Sign from '~/components/AuthWrapper/signIn';
import Footer from '~/components/Footer';
import { ApplicationState } from '~/store';
import { AppControllersState } from '~/store/ducks/appControllers/types';
import {
  companyRequest,
  preSignInRequest,
  requestPwdRequest,
  setCountryCompany,
  signInRequest,
} from '~/store/ducks/auth/actions';
import { AuthState, RequestSignIn } from '~/store/ducks/auth/types';
import { multipleLanguageRequest } from '~/store/ducks/language/actions';
import { Container, ContentWrapper } from './styles';

const _reCaptchaRef = React.createRef<ReCAPTCHA>();

interface State {
  amount: string;
  password: string;
  weight: string;
  weightRange: string;
  showPassword: boolean;
  ownership: any;
  themeReCAPTCHA: string | undefined;
  isVerified: boolean;
  email: string;
  recaptcha: string;
  match: any;
}

interface StateProps {
  profile: any;
  language: any;
  auth: AuthState;
  appControllers: AppControllersState;
  common: any;
}

interface DispatchProps {
  preSignInRequest(preSignIn: RequestSignIn): void;
  requestPwdRequest(preSignIn: RequestSignIn): void;
  signInRequest(signIn: RequestSignIn): void;
  multipleLanguageRequest(language: string): void;
  setCountryCompany(countryCompany: any): void;
  companyRequest(company: string): void;
}

type Props = StateProps & DispatchProps & State;

class SignIn extends Component<Props> {
  state = {
    amount: '',
    password: '',
    weight: '',
    weightRange: '',
    showPassword: false,
    ownership: '',
    ownershipStringValue: '',
    identificationKey: '',
    identificationkeyerror: false,
    ownershiptypeerror: false,
    isVerified: false,
    themeReCAPTCHA: undefined,
    email: '',
    recaptcha: '',
    visible: true,
  };

  componentDidMount() {
    const { multipleLanguageRequest, companyRequest, match } = this.props;
    multipleLanguageRequest('ptbr');

    companyRequest(match.params.country_company);
  }

  handleChangeOwnership = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { common } = this.props;

    const index = common.categoria?.findIndex(
      (el: any) => el.data_holder_cat_id == event.target.value,
    );

    if (index !== -1) {
      const data = common.categoria[index].data_holder_cat_name;

      this.setState({
        ownership: event.target.value,
        ownershiptypeerror: false,
        ownershipStringValue: data,
      });
    } else {
      this.setState({
        ownership: event.target.value,
        ownershiptypeerror: false,
      });
    }
  };

  handleChangeIdentificationKey = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    this.setState({
      identificationKey: event.target.value,
      identificationkeyerror: false,
    });
  };

  handleChange =
    (prop: keyof State) => (event: React.ChangeEvent<HTMLInputElement>) => {
      this.setState({ ...this.state, [prop]: event.target.value });
    };

  handleClickShowPassword = () => {
    this.setState({ ...this.state, showPassword: !this.state.showPassword });
  };

  handleMouseDownPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
  };

  //@ts-ignore
  verifyCallback = response => {
    if (response) {
      this.setState({ isVerified: true, recaptcha: response });
    }
  };

  expiredCallback = () => {
    this.setState({ isVerified: false });
  };

  handleChangeRadio = (event: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({ email: (event.target as HTMLInputElement).value });
  };

  preLogin = async () => {
    const { identificationKey, isVerified, ownership, recaptcha } = this.state;
    const { preSignInRequest, auth } = this.props;

    const identificationKeyChanged = identificationKey.replace(/[^\d]+/g, '');

    if (ownership === '') {
      this.setState({ ownershiptypeerror: true });
    }

    if (identificationKeyChanged === '' && !identificationKey) {
      this.setState({ identificationkeyerror: true });
    }

    if (
      ownership === '' ||
      (identificationKeyChanged === '' && !identificationKey)
    ) {
      toast.error(
        'Necessário o preenchimento de todos os campos para solicitar a senha de acesso.',
      );
    }

    if (!isVerified) {
      toast.error('Por favor, preencha o reCAPTCHA');
    }

    if (
      isVerified &&
      ownership !== '' &&
      (!!identificationKey || identificationKeyChanged.length)
    ) {
      if (ownership === '5' && auth.company.country_company_id === 2) {
        preSignInRequest({
          recaptcha: recaptcha,
          identificationKey: identificationKey,
          ownershipType: ownership,
          countryCompanyId: auth.company.country_company_id,
        });
      } else {
        preSignInRequest({
          recaptcha: recaptcha,
          identificationKey: identificationKeyChanged,
          ownershipType: ownership,
          countryCompanyId: auth.company.country_company_id,
        });
      }

      _reCaptchaRef.current?.reset();
      this.setState({ isVerified: false });
    }
  };

  requestPwd = () => {
    const { identificationKey, isVerified, ownership, recaptcha } = this.state;
    const { requestPwdRequest, appControllers, auth } = this.props;

    const identificationKeyChanged = identificationKey.replace(/[^\d]+/g, '');

    if (appControllers.emailSelected === undefined) {
      toast.error(
        `Necessária a seleção de um e-mail para receber a sua senha de acesso
        ao Portal LGPD. Caso os e-mails exibidos não sejam válidos, favor entrar
        em contato com o DPO.`,
      );
    }

    if (!isVerified) {
      toast.error('Por favor, preencha o reCAPTCHA');
    }

    if (isVerified && appControllers.emailSelected !== undefined) {
      if (ownership === '5' && auth.company.country_company_id === 2) {
        requestPwdRequest({
          recaptcha: recaptcha,
          identificationKey: identificationKey,
          ownershipType: ownership,
          countryCompanyId: auth.company.country_company_id,
          emailIndex: appControllers.emailSelected,
        });
      } else {
        requestPwdRequest({
          recaptcha: recaptcha,
          identificationKey: identificationKeyChanged,
          ownershipType: ownership,
          countryCompanyId: auth.company.country_company_id,
          emailIndex: appControllers.emailSelected,
        });
      }

      _reCaptchaRef.current?.reset();
      this.setState({ isVerified: false });
    }
  };

  signIn = () => {
    const { identificationKey, isVerified, ownership, recaptcha, password } =
      this.state;
    const { signInRequest, auth } = this.props;

    const identificationKeyChanged = identificationKey.replace(/[^\d]+/g, '');

    if (password.length === 0) {
      toast.error(`Por favor insira sua senha.`);
    }

    if (!isVerified) {
      toast.error('Por favor, preencha o reCAPTCHA');
    }

    if (isVerified && password.length > 0) {
      if (ownership === '5' && auth.company.country_company_id === 2) {
        signInRequest({
          recaptcha: recaptcha,
          identificationKey: identificationKey,
          ownershipType: ownership,
          countryCompanyId: auth.company.country_company_id,
          pwd: password,
        });
      } else {
        signInRequest({
          recaptcha: recaptcha,
          identificationKey: identificationKeyChanged,
          ownershipType: ownership,
          countryCompanyId: auth.company.country_company_id,
          pwd: password,
        });
      }

      _reCaptchaRef.current?.reset();
      this.setState({ isVerified: false });
    }
  };

  setLogo = (company: number) => {
    if (company === 1) {
      return logoSky;
    } else {
      return DIRECTV_GO;
    }
  };

  toggleVisible = () => {
    this.setState({ visible: !this.state.visible });
  };

  render() {
    const {
      ownership,
      ownershipStringValue,
      themeReCAPTCHA,
      showPassword,
      password,
      identificationKey,
      identificationkeyerror,
      ownershiptypeerror,
    } = this.state;

    const { profile, language, appControllers, auth } = this.props;

    return (
      <>
        <Container>
          <div
            className="message-alert"
            style={{ display: this.state.visible ? '' : 'none' }}
          >
            <Button onClick={this.toggleVisible}>
              <AiOutlineClose />
            </Button>
            <div className="content-small">
              <div className="vrio-corp">
                <span>Vrio Corp</span>
              </div>

              <div className="welcome">
                <h2>{language?.login?.bemVindo}</h2>
                <h1>{language?.login?.LGPDSystem}</h1>
              </div>
            </div>

            {auth?.company?.country_company_id ? (
              <img
                src={this.setLogo(auth?.company.country_company_id)}
                alt={`logo ${auth?.company?.company?.company_name?.toUpperCase()}`}
              />
            ) : (
              ''
            )}
            <h1>Melhor visualização através de um Desktop.</h1>
          </div>
          <ContentWrapper>
            <div className="content">
              <div className="vrio-corp">
                <span>Vrio Corp</span>
              </div>
              <div className="image-country">
                <span>country</span>
              </div>
              <div className="welcome">
                <h2>{language?.login?.bemVindo}</h2>
                <h1>{language?.login?.LGPDSystem}</h1>
              </div>
            </div>

            <>
              {appControllers.authenticationStep === 1 && (
                <Sign
                  nexAuth={this.preLogin}
                  company={`${auth.company?.company?.company_name}-${auth.company?.country?.country_name}`}
                  ownership={ownership}
                  handleChangeOwnership={this.handleChangeOwnership}
                  identificationKey={identificationKey}
                  handleChangeIdentificationKey={
                    this.handleChangeIdentificationKey
                  }
                  ownershiptypeerror={ownershiptypeerror}
                  identificationkeyerror={identificationkeyerror}
                >
                  {process.env.REACT_APP_RECAPTCHA_SITE_KEY && (
                    <ReCAPTCHA
                      //@ts-ignore
                      style={{ display: 'inline-block' }}
                      theme={themeReCAPTCHA}
                      ref={_reCaptchaRef}
                      sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
                      onChange={this.verifyCallback}
                      onExpired={this.expiredCallback}
                      //@ts-ignore
                      asyncScriptOnLoad={this.asyncScriptOnLoad}
                    />
                  )}
                </Sign>
              )}

              {appControllers.authenticationStep === 2 && (
                <RequestPassword
                  nexAuth={() => this.requestPwd()}
                  list={profile?.user?.emails && profile?.user?.emails}
                >
                  {process.env.REACT_APP_RECAPTCHA_SITE_KEY && (
                    <ReCAPTCHA
                      //@ts-ignore
                      style={{ display: 'inline-block' }}
                      theme={themeReCAPTCHA}
                      ref={_reCaptchaRef}
                      sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
                      onChange={this.verifyCallback}
                      onExpired={this.expiredCallback}
                      //@ts-ignore
                      asyncScriptOnLoad={this.asyncScriptOnLoad}
                    />
                  )}
                </RequestPassword>
              )}

              {appControllers.authenticationStep === 3 && (
                <>
                  <EnterPassword
                    nexAuth={this.signIn}
                    showPassword={showPassword}
                    password={password}
                    //@ts-ignore
                    handleChange={this.handleChange('password')}
                    handleClickShowPassword={this.handleClickShowPassword}
                    handleMouseDownPassword={() => this.handleMouseDownPassword}
                    company={`${auth.company?.company?.company_name}-${auth.company?.country?.country_name}`}
                    ownership={ownership}
                    ownershipStringValue={ownershipStringValue}
                    identificationKey={identificationKey}
                  >
                    {process.env.REACT_APP_RECAPTCHA_SITE_KEY && (
                      <ReCAPTCHA
                        //@ts-ignore
                        style={{ display: 'inline-block' }}
                        theme={themeReCAPTCHA}
                        ref={_reCaptchaRef}
                        sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
                        onChange={this.verifyCallback}
                        onExpired={this.expiredCallback}
                        //@ts-ignore
                        asyncScriptOnLoad={this.asyncScriptOnLoad}
                      />
                    )}
                  </EnterPassword>
                </>
              )}
            </>
          </ContentWrapper>
        </Container>
        <Footer />
      </>
    );
  }
}

const mapStateToProps = (state: ApplicationState) => ({
  appControllers: state.appControllers,
  auth: state.auth,
  profile: state.user.profile,
  language: state.language.data,
  common: state.common,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  ...bindActionCreators(
    {
      preSignInRequest,
      requestPwdRequest,
      signInRequest,
      multipleLanguageRequest,
      setCountryCompany,
      companyRequest,
    },
    dispatch,
  ),
});

export default connect(mapStateToProps, mapDispatchToProps)(SignIn);
